import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//create action
export const updateOutletBPR = createAsyncThunk("createOutletBPR", async ({ id, data }) => {
	const response = await axiosHttp.put(`dealer/module-metadata/${id}`, data);
	return response.data;
});

const DealerOutLetsBPRUpdateSlice = createSlice({
	name: "DealerOutLetsBPRUpdateSlice",
	initialState: {
		isLoading: false,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(updateOutletBPR.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(updateOutletBPR.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(updateOutletBPR.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DealerOutLetsBPRUpdateSlice.reducer;
